module.exports = __webpack_public_path__ + "assets/img/thumb-Logitech-Influencer-Video.93a49aa5.jpg";